<script setup>
import {Head} from '@inertiajs/vue3';
import StoreLayout from '@/Layouts/StoreLayout.vue';
import Collection from "@/Pages/Collection/Partials/Collection.vue";
import Container from "@/Components/Container.vue";
import PageTitle from "@/Components/PageTitle.vue";

const props = defineProps({
    title: String,
    items: Object, // Pagination
});
</script>

<template>
    <Head :title="title"/>

    <StoreLayout>
        <PageTitle :title="title"/>
        <Container>
            <Collection :grid-size="3" :items="items"/>
        </Container>
    </StoreLayout>
</template>
